import { endOfMonth, differenceInCalendarDays } from "date-fns";

export abstract class DateUtil {
  static readonly MILISECONDS = 1000;

  static toMiliseconds(epochDate: number) {
    return epochDate * this.MILISECONDS;
  }

  /**
   * Converts a date source into a millisecond timestamp.
   * Returns 0 if the date is invalid or missing.
   */
  static getTime(date: Date | string | number | undefined | null): number {
    if (!date) {
      return 0;
    }
    const d = new Date(date);
    return isNaN(d.getTime()) ? 0 : d.getTime();
  }

  /**
   * Check whether TIME is set properly if the Date
   * does not contain a default time - `T00:00:00Z`
   *
   * @param date
   */
  static isTimeSetFromDate(date: string) {
    return !!date.match("T00:00:00Z");
  }
}

export function getRemainingDaysOfMonth(): number {
  const today = new Date();
  const end = endOfMonth(today);
  // +1 to include today itself
  return differenceInCalendarDays(end, today) + 1;
}
